export const setActiveTab = (data) => {
  return {
    type: "ACTIVE",
    data: data,
  };
};
